import { createStore } from 'vuex'

export default createStore({
  state: {
    token:"",
    num:0
  },
  getters: {
  },
  mutations: {
    updateToken(state,value){
      console.log("123",value)
      state.token = value
    },
    jia(state,value){
      state.num+=value
    },
    reduce(state,value){
      state.num-=value
    }
  },
  actions: {
    jiou(content){
      let a = content.state.num%2;
      if(a){
        alert("现在是奇数")
      }else{
        alert("现在是偶数")
      }
    },
    cheng(content,value){
      content.state.num *=value
    }
  },
  modules: {
  }
})
